import axios from 'axios'
import jsonpAdapter from './jsonpAdapter'
import {
    GET_HOME_BANNERS,
    GET_HOME_OFFER_DETAIL,
    PRODUCTS_LIST
} from '../utils/UrlConstants'

export const getProductList = (bank) =>
    axios.get(PRODUCTS_LIST.replace(':origin', bank), { timeout: 20000 })

export const getHomeBanners = () => {
    return axios.get(GET_HOME_BANNERS, {
        timeout: 20000,
        params: { callbackName: 'homeBanners' },
        adapter: jsonpAdapter
    })
}

export const getHomeOfferDetail = (path) => {
    return axios.get(GET_HOME_OFFER_DETAIL.replace(':path', path), {
        timeout: 20000,
        params: { callbackName: 'homeOfferDetail' },
        adapter: jsonpAdapter
    })
}
